import { SubCategoryRepository } from '../../domain/repositories/sub-category.repository';
import { SubCategoryEntity } from '../../domain/entities/sub-category.entity';

export class GetSubCategoriesUseCase {
  constructor(private readonly subCategoryRepository: SubCategoryRepository) {}

  async execute(options?: {
    activeOnly?: boolean;
    categoryId?: string;
    search?: string;
  }): Promise<SubCategoryEntity[]> {
    return this.subCategoryRepository.getSubCategories(options);
  }
}
